webpackJsonp([20587081441290],{

/***/ 377:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Hero":"src-components-SuccessStories-Hero----Hero-module---Hero---3dbc4"};

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeroModule = __webpack_require__(377);
	
	var _HeroModule2 = _interopRequireDefault(_HeroModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _HeroModule2.default.Hero },
	    _react2.default.createElement(
	      'h1',
	      { className: 'h1' },
	      props.title
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Story__top":"src-components-SuccessStories-StoryCards----StoryCards-module---Story__top---1lc6e","Story__Left":"src-components-SuccessStories-StoryCards----StoryCards-module---Story__Left---3yZLa","Story__Left__Image":"src-components-SuccessStories-StoryCards----StoryCards-module---Story__Left__Image---27Z3H","Story__right":"src-components-SuccessStories-StoryCards----StoryCards-module---Story__right---6WOgo","Story__biography":"src-components-SuccessStories-StoryCards----StoryCards-module---Story__biography---1bQmw","Story__video":"src-components-SuccessStories-StoryCards----StoryCards-module---Story__video---2kSfl","Story__quote":"src-components-SuccessStories-StoryCards----StoryCards-module---Story__quote---21DU5","stats":"src-components-SuccessStories-StoryCards----StoryCards-module---stats---1wLK6","stats__item":"src-components-SuccessStories-StoryCards----StoryCards-module---stats__item---f0uQh","logos":"src-components-SuccessStories-StoryCards----StoryCards-module---logos---2IWta"};

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VimeoEmbed = __webpack_require__(117);
	
	var _VimeoEmbed2 = _interopRequireDefault(_VimeoEmbed);
	
	var _StoryCardsModule = __webpack_require__(747);
	
	var _StoryCardsModule2 = _interopRequireDefault(_StoryCardsModule);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoryCards = function StoryCards(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    props.successStoryCards.map(function (story, i) {
	      return _react2.default.createElement(
	        'div',
	        { className: _StoryCardsModule2.default.Story, key: i },
	        _react2.default.createElement(
	          'div',
	          { className: _StoryCardsModule2.default.Story__top },
	          _react2.default.createElement(
	            'div',
	            { className: _StoryCardsModule2.default.Story__Left },
	            _react2.default.createElement(
	              'h2',
	              null,
	              story.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _StoryCardsModule2.default.Story__Left__Image },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: story.profileImage.sizes, alt: story.profileImage.title, className: 'profileImage' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _StoryCardsModule2.default.Story__right },
	            _react2.default.createElement(
	              'div',
	              { className: _StoryCardsModule2.default.stats },
	              story.stats.map(function (stat, iterator) {
	                return _react2.default.createElement(
	                  'p',
	                  { className: _StoryCardsModule2.default.stats__item, key: iterator },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    stat.title
	                  ),
	                  ' ',
	                  stat.text.text
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _StoryCardsModule2.default.logos },
	              story.logos.map(function (logo, iterator) {
	                return _react2.default.createElement(_gatsbyImage2.default, { sizes: logo.sizes, alt: logo.title, key: iterator });
	              })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: _StoryCardsModule2.default.Story__biography },
	              story.biopgraphy.biopgraphy
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _StoryCardsModule2.default.Story__video },
	          _react2.default.createElement(_VimeoEmbed2.default, {
	            url: story.interviewVideoLink,
	            poster: story.interviewVideoPlaceholder ? story.interviewVideoPlaceholder : '',
	            loop: false,
	            autoplay: true,
	            controls: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _StoryCardsModule2.default.Story__quote },
	          _react2.default.createElement(
	            'p',
	            { className: 'quote' },
	            story.quote.quote
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = StoryCards;
	module.exports = exports['default'];

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _Fellows = __webpack_require__(25);
	
	var _Fellows2 = _interopRequireDefault(_Fellows);
	
	var _Hero = __webpack_require__(343);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _KeyStats = __webpack_require__(128);
	
	var _KeyStats2 = _interopRequireDefault(_KeyStats);
	
	var _StoryCards = __webpack_require__(548);
	
	var _StoryCards2 = _interopRequireDefault(_StoryCards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuccessStories = function (_React$Component) {
	  _inherits(SuccessStories, _React$Component);
	
	  function SuccessStories() {
	    _classCallCheck(this, SuccessStories);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SuccessStories.prototype.componentDidMount = function componentDidMount() {
	    var ScrollReveal = __webpack_require__(149);
	
	    window.setTimeout(function () {
	      window.sr = ScrollReveal();
	      sr.reveal('.keystat', { duration: 600, delay: 200 }, 80);
	      sr.reveal('.quote', { duration: 600 });
	      sr.reveal('.profileImage', { duration: 1600, opacity: 0.4, scale: 0.9, delay: -200 });
	    }, 200);
	  };
	
	  SuccessStories.prototype.render = function render() {
	    var _props$data = this.props.data,
	        page = _props$data.page,
	        fellows = _props$data.fellows;
	
	    var seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : '';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'success' },
	      _react2.default.createElement(_CustomHelmet2.default, { data: page.seoData }),
	      _react2.default.createElement(_Hero2.default, {
	        title: page.title
	      }),
	      _react2.default.createElement(_KeyStats2.default, {
	        keystats: page.keyStats
	      }),
	      _react2.default.createElement(_StoryCards2.default, {
	        successStoryCards: page.successStoryCards
	      }),
	      _react2.default.createElement(_Fellows2.default, {
	        title: fellows.title,
	        cards: fellows.fellowsCards,
	        link: fellows.link
	      }),
	      _react2.default.createElement(_Apply2.default, {
	        title: 'It\'s time to break out from the expected',
	        buttonText: 'Request Info',
	        buttonUrl: '/#signup'
	      })
	    );
	  };
	
	  return SuccessStories;
	}(_react2.default.Component);
	
	exports.default = SuccessStories;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-success-stories-js-383a85bdead2fd7ec89a.js